import { cn } from "@/lib/utils";
import { CircleHelp } from "lucide-react";

interface EmptyProps {
  children: React.ReactNode;
  className?: string;
  iconClassName?: string;
  action?: React.ReactNode;
  when: boolean;
}

export default function Empty({
  children,
  className,
  iconClassName,
  action,
  when,
}: EmptyProps) {
  if (!when) return null;
  return (
    <div
      className={cn(
        "m-4 min-h-72 flex flex-col place-content-center items-center gap-7 text-lg",
        className,
      )}
    >
      <CircleHelp className={cn("w-12 h-12", iconClassName)} />
      <p>{children}</p>
      {action && <footer>{action}</footer>}
    </div>
  );
}
